import React from 'react';
import { isWeekend } from '../../utils/date-utils';
import { isHoliday, getHolidayName } from '../../utils/holiday-calculator';

export default function DatePickerWithValidation({ value, onChange, error }) {
  const selectedDate = value ? new Date(value) : null;
  const weekend = selectedDate && isWeekend(selectedDate);
  const holiday = selectedDate && isHoliday(selectedDate);
  const holidayName = selectedDate && getHolidayName(selectedDate);

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '13px',
        fontWeight: '600',
        color: '#2b2b2b',
        marginBottom: '6px'
      }}>
        Start Date *
      </label>

      <input
        type="date"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: error ? '1px solid #dc2626' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none'
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = '#8B4513';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = '#ddd';
        }}
      />

      {error && (
        <div style={{
          fontSize: '12px',
          color: '#dc2626',
          marginTop: '4px'
        }}>
          {error}
        </div>
      )}

      {/* Weekend Warning */}
      {weekend && !error && (
        <div style={{
          fontSize: '12px',
          color: '#f59e0b',
          marginTop: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          <span>⚠️</span>
          <span>This is a weekend. First work day will be next business day.</span>
        </div>
      )}

      {/* Holiday Warning */}
      {holiday && !error && (
        <div style={{
          fontSize: '12px',
          color: '#f59e0b',
          marginTop: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          <span>🎉</span>
          <span>This is {holidayName}. First work day will be next business day.</span>
        </div>
      )}

      {!weekend && !holiday && !error && (
        <div style={{
          fontSize: '11px',
          color: '#999',
          marginTop: '4px'
        }}>
          Job will start on this date (if business day)
        </div>
      )}
    </div>
  );
}